import React from "react";
import { Tabs, Tab } from "react-bootstrap";
// import Customization from "./widget/Customization";
import Customization from "./Customization";
import WidgetInstallationGuide from "./WidgetInstallationGuide";
const TabsWi = () => {
  return (
    <Tabs
      defaultActiveKey="customize"
      id="uncontrolled-tab-example"
      className="mb-3"
    >
      <Tab eventKey="customize" title="Customize">
        <Customization />
      </Tab>
      <Tab eventKey="install" title="Install">
        <WidgetInstallationGuide />
      </Tab>
    </Tabs>
  );
};

export default TabsWi;
